import {DTCampaignNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {getBaseHeader} from './utils';

const CAMPAIGN_PURPOSE = 'Purpose: Campaign logic entry point when ad is requested';

export function campaignCardToText(card: DTCampaignNode, _mode: 'short' | 'full'): string {
  const header = getBaseHeader(card);

  return [header, CAMPAIGN_PURPOSE].join('\n');
}
